import userService from './user.service';
import { uploadThroughEngine } from './solicitation/documents.engine';

const pictureOf = async (id, picture) => {
    if (!picture || picture.url) return picture;
    const viaEngine = await uploadThroughEngine({ files: [picture], targetKind: 'userAvatar', targetOf: () => ({ userId: id }) });
    return viaEngine ? viaEngine[0].result.document : picture;
};

const saveProfileInfo = async (id, data) => userService.saveProfileInfo(id, { ...data, picture: await pictureOf(id, data.picture) });

export default { saveProfileInfo };
